export const disableScroll = disable => {
  document.body.style.overflow = disable ? 'hidden' : 'auto';
};
